import React from 'react';
import { Video } from './Video';
import { useBlockContext } from '../../BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export type VideoWithMetaInfoType = {
  caption: string;
  copyright: string;
} & Video;

export function VideoWithMetaInfo({
  source,
  contentType,
  captionsFile,
  caption,
  copyright,
}: VideoWithMetaInfoType) {
  const { t } = useSonTranslation('glossary');
  const { uuid } = useBlockContext();

  return (
    <figure className="content-video__figure">
      <div className="content-video__wrapper">
        <Video
          source={source}
          captionsFile={captionsFile}
          contentType={contentType}
          ariaDescribedby={`content-video-${uuid}`}
        />
        <p className="content-video__copyright font-light-13-17" id={`content-video-${uuid}`}>
          <dfn className="invisible">{`${t('copyright')}:`}</dfn>
          <span aria-hidden="true">©</span> {copyright}
        </p>
      </div>
      {caption && (
        <figcaption className="content-video__figcaption">
          <p>{caption}</p>
        </figcaption>
      )}
    </figure>
  );
}
